export const InfoTestStudentBannerTranslations = {
  NEW_PRACTICE_MODES: {
    es: '¡Llegaron los nuevos modos de práctica!',
    en: 'New practice modes are here!',
    cat: 'Els nous modes de pràctica estan aquí!',
    eus: 'Uneko moduak ezagutu dituzu!',
    pt: 'Os novos modos de prática estão aqui!'
  },
  INFO_TEST_BANNER_DESCRIPTION: {
    es: 'Dale caña al estudio como nunca antes. Elige tu modo favorito y demuestra lo que sabes.',
    en: 'Give your study a boost like never before. Choose your favorite mode and show what you know.',
    cat: 'Dona un cop d’aleta al estudi com mai abans. Elige el teu mode preferit i demostra el que saps.',
    eus: 'Eskubide gehiago eman zure ikastarok. Aukeratu zure hobetu gisa eta erakutsi zer modu duzu.',
    pt: 'Dê um impulso ao seu estudo como nunca antes. Escolha o seu modo favorito e demonstre o que sabe.'
  },
  GO_TO_PRACTICE: {
    es: 'Ir a practicar',
    en: 'Go to practice',
    cat: 'Anar a practicar',
    eus: 'Egin erakutsi',
    pt: 'Ir para prática'
  }
};
